import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';

import { LayoutModule } from './views/layout/layout.module';
import { AuthGuard } from './core/authentication/auth.guard';

import { AppComponent } from './app.component';

import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from './core/authentication/interceptor';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { WebsocketService } from './pixeltrade/services/websocket.sevice';
import { SimpleTimer } from 'ng2-simple-timer';
import { NgReduxModule, NgRedux } from '@angular-redux/store';
import { store, IAppState } from './store';
import { TrendStockActions } from './pixeltrade/strategies/trend-stocks/trendstock.action';
import { OrderContextActions } from './pixeltrade/strategies/trend-stocks/order-context.action';
import { ClipboardModule } from 'ngx-clipboard';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    HttpClientModule,
    NgReduxModule,
    ClipboardModule
  ],
  providers: [
    DatePipe,
    WebsocketService,
    SimpleTimer,
    TrendStockActions,
    OrderContextActions,
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
    { provide: APP_BASE_HREF, useValue: '/app' },
    AuthGuard,
    {

      provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
        }
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(ngRedux: NgRedux<IAppState>) {
    ngRedux.provideStore(store);
  }
}
